<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';

export default Vue.extend({
    filters: {
        fileName(path) {
            return path.substring(path.indexOf('_') + 1, path.length);
        }
    },
    computed: {
        ...mapState({
            form: state => state.contract.contractManagement.form,
            contract: state => state.contract
        }),
        filesList: {
            get() {
                return this.form.part === 'basic' || this.form.subPart === 'arrivalDeparture' ?
                    this.form[this.form.part][this.form.subPart].files :
                    this.form[this.form.part][this.form.subPart][this.form.index].files;
            }
        },
        s3: {
            get() {
                return this.form.part === 'basic' || this.form.subPart === 'arrivalDeparture' ?
                    this.form[this.form.part][this.form.subPart].s3 :
                    this.form[this.form.part][this.form.subPart][this.form.index].s3;
            }
        }
    },
    watch: {
        contract: {
            handler() {
                this.resize();
            },
            deep: true
        }
    },
    mounted() {
        this.resize();
    },
    methods: {
        ...mapActions({
            contractManagementFormSet: 'contract/contractManagementFormSet',
            contractManagementFormFileRemove: 'contract/contractManagementFormFileRemove',
            contractManagementFormFileDelete: 'contract/contractManagementFormFileDelete',
            contractManagementFormFileDownload: 'contract/contractManagementFormFileDownload',
        }),
        add(obj) {
            this.contractManagementFormSet(obj);
            // Clear the input field value to ensure that the upload drag and drop works
            // when remove and then re-insert same file
            document.getElementById('contract-management-edit-upload__input-file').value = "";
        },
        deleteFile(obj) {
            let confirm = window.confirm(this.$t('contractManagement.edit.form.upload.confirm'));
            if (confirm) {
                this.contractManagementFormFileDelete(obj);
            }
        },
        resize() {
            if (this.fileList || this.s3) {
                const elementCount = this.filesList.length + this.s3.length;
                const element = document.getElementById('contract-management-edit-upload__input-file');
                if(element) {
                    element.style.height = (elementCount * 30) + 'px';
                }
            }
        }
    }
});
</script>
<template>
    <div v-if="form.subPart !== 'notes'" class="contract-management-edit-upload">
        <div class="contract-management-edit-upload__content">
            <div id="contract-management-edit-upload__dropbox" class="contract-management-edit-upload__dropbox">
                <input id="contract-management-edit-upload__input-file"
                       :name="form.subPart"
                       type="file"
                       multiple
                       accept=".xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf"
                       class="contract-management-edit-upload__input-file"
                       @change="add({part: form.part, subPart: form.subPart, files: $event.target.files})">
                <div v-if="filesList.length === 0 && s3.length === 0" class="contract-management-edit-upload__text" >
                    <p class="contract-management-edit-images__icon"><i class="fa fa-file-o"/></p>
                    <p class="contract-management-edit-upload__initial">{{ $t('contractManagement.edit.form.upload.initial') }}</p>
                    <p class="contract-management-edit-upload__accepted">{{ $t('contractManagement.edit.form.upload.accepted') }}</p>
                </div>
                <div v-if="filesList.length > 0 || s3.length > 0">
                    <ul class="contract-management-edit-upload__file-list">
                        <li v-for="(file, index) in filesList" :key="'upload_' + index">
                            <span class="contract-management-edit-upload__btn contract-management-edit-upload__remove-button"
                                  @click="contractManagementFormFileRemove({part: form.part, subPart: form.subPart, index: index, type: 'files'})">
                                <i class="fa fa-minus-square"/>
                            </span>
                            <span class="contract-management-edit-upload__file">{{ file.name }}</span>
                        </li>
                        <li v-for="(file, index) in s3" :key="'download_' + index">
                            <span class="contract-management-edit-upload__btn contract-management-edit-upload__delete-button"
                                  @click="deleteFile({part: form.part, subPart: form.subPart, contractId: form.contractId, index: index, subIndex: form.index})">
                                <i class="fa fa-trash"/>
                            </span>
                            <span class="contract-management-edit-upload__btn contract-management-edit-upload__download-button" @click="contractManagementFormFileDownload({part: form.part, subPart: form.subPart, subIndex: form.index, index: index})">
                                <i class="fa fa-download"/>
                            </span>
                            <span class="contract-management-edit-upload__file">{{ file | fileName }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditUpload/ContractManagementEditUpload.vue